module.exports = __webpack_public_path__ + "speed_physics.jpg?c5704a38826b4543b76390519a6097d8";